// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    background-color: #f5f5f5;
    color: #373435;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 1001;
  }

  .header-leftSide {
    display: flex;
  }
  
  .hamburger-menu {
    font-size: 1.5rem;
    background: none;
    border: none;
    color: #373435;
    cursor: pointer;
    margin-right: 1rem;
  }

  .header-logo {
    display: block;
    margin: 0 auto;
    height: 75px; 
    width: 100px; 
    object-fit: contain; 
  }
  
  .header-title {
    font-size: 1.5rem;
    font-weight: bold;
    margin: 0;
  }
  
  .header-right {
    display: flex;
    align-items: center;
  }
  
  .header-info {
    display: flex;
    gap: 10px;
    text-align: right;
    margin-right: 1.5rem;
    align-items: center;
  }
  
  .header-info p {
    margin: 0;
    font-size: 15px;
  }
  @media screen and (max-width: 800px) {

    .login-time {
      display: none
    }

    .login-ip {
      display: none;
    }
  }
  
  .logout-button {
    background-color: #fb3d4e;
    color: #fff;
    border: 1px solid #fb3d4e;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    font-size: 1rem;
    cursor: pointer;
    margin-right: 20px;
  }
  
  .logout-button:hover {
    background: transparent;
    color: #f44336;
    border: 1px solid #f44336;
  }

  .logout-icon {
    margin-right: 5px;
  }
  

  .profile-page {
    cursor: pointer;
    font-size: 30px;
  }

  .profile-page .userIcon {
    color: #44a67e;
  }
  .profile-page a {
    font-size: 20px;
    font-weight: 600;
    padding: 5px;
    border-radius: 10px;
    color: #44a67e;
  }`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf,WAAW;IACX,MAAM;IACN,OAAO;IACP,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;EACA;;IAEE;MACE;IACF;;IAEA;MACE,aAAa;IACf;EACF;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;;;EAGA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,cAAc;EAChB","sourcesContent":[".header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 1rem;\r\n    background-color: #f5f5f5;\r\n    color: #373435;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n    position: fixed;\r\n    width: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 1001;\r\n  }\r\n\r\n  .header-leftSide {\r\n    display: flex;\r\n  }\r\n  \r\n  .hamburger-menu {\r\n    font-size: 1.5rem;\r\n    background: none;\r\n    border: none;\r\n    color: #373435;\r\n    cursor: pointer;\r\n    margin-right: 1rem;\r\n  }\r\n\r\n  .header-logo {\r\n    display: block;\r\n    margin: 0 auto;\r\n    height: 75px; \r\n    width: 100px; \r\n    object-fit: contain; \r\n  }\r\n  \r\n  .header-title {\r\n    font-size: 1.5rem;\r\n    font-weight: bold;\r\n    margin: 0;\r\n  }\r\n  \r\n  .header-right {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  \r\n  .header-info {\r\n    display: flex;\r\n    gap: 10px;\r\n    text-align: right;\r\n    margin-right: 1.5rem;\r\n    align-items: center;\r\n  }\r\n  \r\n  .header-info p {\r\n    margin: 0;\r\n    font-size: 15px;\r\n  }\r\n  @media screen and (max-width: 800px) {\r\n\r\n    .login-time {\r\n      display: none\r\n    }\r\n\r\n    .login-ip {\r\n      display: none;\r\n    }\r\n  }\r\n  \r\n  .logout-button {\r\n    background-color: #fb3d4e;\r\n    color: #fff;\r\n    border: 1px solid #fb3d4e;\r\n    padding: 0.5rem 1rem;\r\n    border-radius: 4px;\r\n    font-size: 1rem;\r\n    cursor: pointer;\r\n    margin-right: 20px;\r\n  }\r\n  \r\n  .logout-button:hover {\r\n    background: transparent;\r\n    color: #f44336;\r\n    border: 1px solid #f44336;\r\n  }\r\n\r\n  .logout-icon {\r\n    margin-right: 5px;\r\n  }\r\n  \r\n\r\n  .profile-page {\r\n    cursor: pointer;\r\n    font-size: 30px;\r\n  }\r\n\r\n  .profile-page .userIcon {\r\n    color: #44a67e;\r\n  }\r\n  .profile-page a {\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    padding: 5px;\r\n    border-radius: 10px;\r\n    color: #44a67e;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
